import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import completedTickImg from '../../images/icons/tick_icon_white.png';
import bottomPointsIcon from '../../images/icons/points_icon.png';
import HmEventRegistry from '../../model/HmEventRegistry';

class AbstractTopicComponent extends LoggedInPage{
    constructor(props){
        super(props);
        this.state={
            gifAnimSrc:'',
            gifSrc: '',
            imgSrc: '',
            boxColor: ''
        }
        this.onTopicStart = this.onTopicStart.bind(this);  	
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
    }

    componentDidMount(){	
        let imgPath;
		let animImgPath;
		let colourCode;
		let boxDefaultColor = "#8D6E63";
		let boxDefaultImg = "box_default.png";
		
		let boxcolor = boxDefaultColor;
		let boxImgSrc = require("../../images/animations/"+boxDefaultImg);
		let boxgifsrc = require("../../images/animations/"+boxDefaultImg);
		
		//console.log("lalala: topic::",this.props.topic);

		if(imgPath && imgPath != ""){
			boxImgSrc = imgPath;
		}
		if(animImgPath && animImgPath != ""){
			boxgifsrc = animImgPath;
		}
		if(colourCode && colourCode != ""){
			boxcolor = colourCode;
		}

		this.setState({
				imgSrc: boxImgSrc,
				gifAnimSrc:boxgifsrc,
					gifSrc: boxImgSrc,
					boxColor: boxcolor
			});
		
		
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }

    onTopicStart(){
        // console.log(this.props.topic.subTopicMap);	
        // this.props.callbackParent(this.props.topic,this.props.dataIndex,this.state.boxColor);
      }
    
      handleMouseOver() {
        this.setState({
          imgSrc: this.state.gifAnimSrc
        });    
      }
    
      handleMouseOut() {
        this.setState({
             imgSrc: this.state.gifSrc
        });
      }
    
      getUserTopicPoints(){
          return 0;
      }
    
      getTopicPoints(){
           return 0;
      }

      getLesssonsActionLabel(){
        return this.rb("home.start");
      }

      getTestsActionLabel(){
        return this.rb("home.start");
      }

      topicLocked(){
        let locked = false;
        return locked;
      }

      getTopicBottomSection(){
           let me = this;
           let topicStatus = '';
           let gradeName = '';
           let topicName= '';
           let lessonOnlyMode = false;
          if(lessonOnlyMode == true){
              return(
                        <div className="card-body card-bottom text-center lessononlytopic">	
                             <div className="card-link tileLink showcursor" onClick={this.onTopicStart}>		    		    	
                                    <h5>
                                      {(() => {
                                          if(this.topicLocked() === true){
                                              return this.rb("topic.locked");
                                          }
    
                                          switch (topicStatus) {
                                          case "COMPLETED":   return this.rb("lesson.watched");
                                          case "IN_PROGRESS": return this.rb("home.resume");
                                          default:      return this.rb("home.start");
                                        }
                                      })()}
                                    </h5>
                                </div>
                           </div>
                    );
          }else{
              return(
                        <div className="card-body card-bottom">			      		    
                               <span className="card-link user-points">
                                   <img className="bottomPointsIcon" src={bottomPointsIcon} />
                                   <span className="user-points">{this.getUserTopicPoints()}</span>
                                    / 
                                   <span className="points">{this.getTopicPoints()}</span>
                               </span>
                             <div className="card-link float-right tileLink showcursor" onClick={this.onTopicStart}>		    		    	
                                    <h5>
                                      {(() => {
                                          if(me.topicLocked() === true){
                                              return this.rb("topic.locked");
                                          }
    
                                        switch (topicStatus) {
                                          case "COMPLETED":   return this.rb("home.revise");
                                          case "IN_PROGRESS": return this.rb("home.resume");
                                          default:      return this.rb("home.start");
                                        }
                                      })()}
                                    </h5>
                                </div>
                           </div>
                    );
          }
        
      }
      
      render() {
          let topicStatus = 'NEW';
          let topicName = '';
          let lessonOnlyMode  = false;
          let selectedGradeLabel = '';
          let topicDescription  = '';
        return (  
            <div className={"card "+selectedGradeLabel}>
            <div className="card-img-top topic text-center" style={{backgroundColor: this.state.boxColor}} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
                    <img className={"bgimg animgif " + ((topicStatus === "COMPLETED" && lessonOnlyMode == false) ? 'opacityInGif' : '')} src={this.state.imgSrc} />
                    {(() => {
                    if(topicStatus === "COMPLETED") {
                        if(lessonOnlyMode == false){
                            return <img className="topiccompletedIcon" src={completedTickImg} />;				    		       
                        }
                    }
                    })()}
                    
                    
            </div>
                <div className="card-img-overlay">
                    <div className="card-title">{topicName}</div>		    			    
                </div>

                <div className="card-body descBody">	    		   
                    <p className="card-text">{topicDescription}</p>
                </div>    
                
            {this.getTopicBottomSection()}
            
        </div>
        );
      }
 }

export default AbstractTopicComponent;



// WEBPACK FOOTER //
// ./src/views/plp/AbstractTopicComponent.js